<template>
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      
        <div class="row">
          <div class="col-12">
            <p class="label">Role: {{ userRole.userRole}}</p>
          </div>
          <div class="col-12">
            <p class="label">Search Screen:</p>
          </div>
          <div class="col-12">
            <div class="selectedComp">
              <div v-for="(data, index) in permissions" :key="index">
                <div class="rect">
                  <span class="tag-title">{{ data }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <p class="label">Organisation Name:</p>
          </div>
          <div class="col-8">
            <p class="label">Legal Entity Name:</p>
          </div>
          <div class="row" v-for="(data, index) in organisations" :key="index">
            <div class="col-4">
              <div>
                <div class="rect">
                  <span class="tag-title">{{ data.name }}</span>
                </div>
              </div>
            </div>
            <div class="col-8">
              <div v-for="(entity, index) in data.legal_entity" :key="index">
                <div class="row">
                  <div class="col-2">
                    From Date: <br/>
                    {{entity.from_date}}  
                  </div>
                  <div class="col-2">
                    To Date:  <br/>
                    {{entity.to_date}}
                  </div>
                  <div class="col-8">
                    <div class="rect">
                      <span class="tag-title">{{ entity.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <footer>
        <popup-bottom-container class="position-fixed marginleft">
            <btn-grp slot="end">
              <btn text="Back" type="secondary" @click="backToWelcomeScreen" />
            </btn-grp>
        </popup-bottom-container>
      </footer>
    </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    userRole: {
      type: Object
    }
  },
  data() {
    return {
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      organisationList:[],
      tempOrgArray:[],
      entityList: [],
      tempEntityList:[],
      permissionList: [
        {
          key: "add_user",
          name: "Add User",
        },
        {
          key: "add_user_permission",
          name: "Add User Permission",
        },
        {
          key: "create_legal_entity",
          name: "Create Legal Entity",
        },
        {
          key: "create_organisation",
          name: "Create Organisation",
        },
        {
          key: "organisation_list",
          name: "Organisation List",
        },
        {
          key: "legal_entity_list",
          name: "Legal Entity List",
        },
        {
          key: "legal_entity_info",
          name: "Legal Entity Info",
        },
        {
          key: "location",
          name: "Location",
        },
        {
          key: "statutory_settings",
          name: "Statutory Settings",
        },
        {
          key: "departments",
          name: "Departments",
        },
        {
          key: "cost_centers",
          name: "Cost Centers",
        },
        {
          key: "designation",
          name: "Designation",
        },
        {
          key: "salary_grade",
          name: "Salary Grade",
        },
        {
          key: "emp_cat_and_sub_cat",
          name: "Emp Cat and Sub-Cat",
        },
        {
          key: "salary_bands",
          name: "Salary Bands",
        },
        {
          key: "misc",
          name: "Misc",
        },
        {
          key: "payroll_preferences",
          name: "Payroll Preferences",
        },
        {
          key: "paygroup",
          name: "Paygroup",
        },
        {
          key: "add_employee",
          name: "Add Employee",
        },
        {
          key: "legacy_data",
          name: "Legacy Data",
        },
        {
          key: "payroll_dashboards",
          name: "Payroll Dashboards",
        },
        {
          key: "it_declarations",
          name: "IT Declarations",
        },
        {
          key: "it_proof_submission",
          name: "IT Proof Submission",
        },
        {
          key: "it_proof_approval",
          name: "IT Proof Approval",
        },
        {
          key: "assign_fixed_non_ctc_component",
          name: "Assign fixed & Non CTC component",
        },
        {
          key: "exit_employee_details",
          name: "Exit employee Details",
        },
        {
          key: "delete_payroll_data",
          name: "Delete payroll data",
        },
        {
          key: "form_16",
          name: "Form 16",
        },
        {
          key: "hold_release_salary",
          name: "Hold/Release salary",
        },
        {
          key: "increment_arrear_override",
          name: "Increment Arrear Override",
        },
        {
          key: "leaves_attendance",
          name: "Leaves Attendance",
        },
        {
          key: "legacy_salary",
          name: "Legacy salary",
        },
        {
          key: "lop_rlop",
          name: "Lop/Rlop",
        },
        {
          key: "revise_salary",
          name: "Revise salary",
        },
        {
          key: "statutory_bonus",
          name: "Statutory Bonus",
        },
        {
          key: "statutory_deduction",
          name: "Statutory Deduction",
        },
        {
          key: "manage_roles",
          name: "Manage Roles",
        },
        {
          key: "download_upload_master_template",
          name: "Download/Upload Master Template",
        },
        {
          key: "ess_management",
          name: "ESS Management",
        },
        {
          key: "payslips_it_sheets",
          name: "Payslips & IT Sheets",
        },
        {
          key: "update_form_24q_acknowledgement",
          name: "Update Form 24Q acknowledgement",
        },
        {
          key: "company",
          name: "Company",
        },
        {
          key: "reportos",
          name: "Reports",
        },
        {
          key: "fbpEligibilityConfig",
          name: "FBP Eligibility Config"
        },
        // {
        //   key: "settings",
        //   name: "Settings",
        // },
        // {
        //   key: "add_new_joinee",
        //   name: "Add New Joinee",
        // },
        // {
        //   key: "add_exiting_employees",
        //   name: "Add Exiting Employees",
        // },
        // {
        //   key: "update_lops_rlops",
        //   name: "Update LOPs/RLOPs",
        // },
        // {
        //   key: "tds_overrides",
        //   name: "TDS Overrides",
        // },
        // {
        //   key: "manage_team_roles",
        //   name: "Manage Team Roles",
        // },
        // {
        //   key: "variable_earnings_deductions",
        //   name: "Variable Earnings & Deductions",
        // },
        {
          key: "approve_and_reject_it_proof",
          name: "Approve and reject IT Proof",
        },
        {
          key: "fbp_settings",
          name: "FBP Settings",
        },
      ],
      permissions: [],
      organisations: [],
    };
  },
  mounted() {
    this.getFetch();
    this.getAllOrgs();
    // this.getLeData();
  },
  computed: {
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
  },
  methods: {
    ...mapActions({
      getFavouriteOrgs: "onboard/organization/fetchFavouriteOrg",
      act_fetchle: "onboard/legal_entities/fetchAll",
    }),

    getFetch() {
      //console.log("Dataa", this.userRole);
      Object.entries(this.userRole.permissions).forEach(element => {
          const permission = this.permissionList.find(i => i.key === element[0]);
          if (permission) {
            this.permissions.push(permission.name);
          }
      });
    },
    
    backToWelcomeScreen() {
      this.$emit('back');
    },

    /** Function to fetch all organisations */
    async getAllOrgs() {
      try {
        let res = await this.getFavouriteOrgs();
        //console.log("ORg name",res);
        this.organisations = [];
        const orgIds = Object.keys(this.userRole['organisations'])
        res.data.payload.data.forEach(element => {
          const orgs = orgIds.find(i => i === element.id);
          if (orgs) {
             this.organisations.push({
              name: element.name,
              legal_entity: [],
            });
            this.getLeData(orgs, element)
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to fetch the List of LEs for an Organisation */
    async getLeData(org, element) {
      try {
          let res = await this.act_fetchle(org);
          //console.log("LEdata name",res);
          const list = [];
          res.data.payload.data.forEach(ele => {
            const legalData = this.userRole['organisations'][org]['legal_entity'].find(i => i.id === ele.id);
            if (legalData) {
              list.push({
                id: ele.id,
                name: ele.legalName,
                from_date: legalData.from_date,
                to_date: legalData.to_date,
              })
              const index = this.organisations.findIndex(i => i.name === element.name)
              if (index > -1) {
                this.organisations[index]['legal_entity'] = list;
              }
          }
        })
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.signup-form {
  width: 350px;
  background-color: #fff;
  border-radius: 4px;
  // box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
  // padding: 16px 40px 25px 40px;
}
.label {
  height: 15px;
  margin-bottom: 9px;
  margin-top: 25px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.first-label {
  height: 15px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.signup-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 4px;
  padding: 15px 9px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}
.signup-btn {
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}
.signin-text {
  display: flex;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
}
.signin-text div {
  height: 15px;
  font-family: Montserrat;
  font-size: 14px;
  color: #868686;
}
.signin-text a {
  text-decoration: none;
}
.phone-number {
  position: relative;
}
.phone-number span {
  position: absolute;
  right: 0;
  color: #0e0e0e;
  opacity: 0.59;
}
@media only screen and (max-width: 600px) {
  .signin-form {
    padding: 16px 20px 25px 20px;
  }
}
.errorMessage {
  color: #e01717;
  padding-top: 5px;
}
.selectedComp {
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
}
.rect {
  padding: 10px 20px 10px 20px;
  margin: 2px;
  border-radius: 21px;
  background-color: #5d409f;
  color: #fff;
  text-align: center;
  display: inline-block;
  img {
    padding-left: 10px;
    top: 4px;
    position: relative;
  }
}
span.tag-title {
  position: relative;
  cursor: none;
}
.addTagBtn {
  top: 54px;
  position: relative;
}
.labelText {
  height: 15px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}
.legalBtn {
  top: 20px;
  position: relative;
}
</style>
